import { render, staticRenderFns } from "./BoundPropertyQuotatorProportional.vue?vue&type=template&id=a25092a0&"
import script from "./BoundPropertyQuotatorProportional.vue?vue&type=script&lang=js&"
export * from "./BoundPropertyQuotatorProportional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports